/*=========================================================================================
File Name: store.js
Description: Vuex store
----------------------------------------------------------------------------------------
Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
Author: Pixinvent
Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
/* eslint-disable array-bracket-newline */
// import Vue from 'vue'
// import Vuex from 'vuex'
// Vue.use(Vuex)

import Vue from 'vue'
import Vuex from 'vuex'

import persist from './persist'
import app from './modules/app'
import auth from './auth'
import authError from './authError'
import wovn from './wovn'
import order from './order'
import modal from './modal'
import bs_app from './modules/bs_app'
import bs_inf from './modules/bs_inf'
import menu from './modules/menu'
import plan from './modules/plan'
import order_old from './modules/order'
import menu_info from './modules/menu_info'
import service from './modules/service'
import spec from './modules/spec'
import createPersistedState from 'vuex-persistedstate'
import mypage from './modules/bs_myp'
import bsSet from './modules/bs_set'
import coupon from './coupon'
// CRM汎用独自対応
import params from './params'
import * as Cookies from 'js-cookie'
import CONST_DATA from '@/mixins/const/constData'
import personalPayment from "./personalPayment";

Vue.use(Vuex)

// CRM汎用独自対応
const namespacedModules = {
  persist,
  auth,
  authError,
  wovn,
  order,
  params,
  modal,
  personalPayment
}


// CRM汎用独自対応
export default new Vuex.Store({
  ...app,
  modules: {
    ...Object.keys(namespacedModules).reduce((acc, k) => {
      acc[k] = {
        ...namespacedModules[k],
        namespaced: true
      }
      return acc
    }, {}),
    bs_app,
    bs_inf,
    menu,
    plan,
    order_old,
    menu_info,
    service,
    mypage,
    spec,
    bsSet,
    coupon
  },
  // CRMとBS両方を残した
  // 理由：CRM独自対応を残す必要だが、pathsに新規値も追加する必要がある（69881チケット対応）
  plugins: [
    createPersistedState({
      key: process.env.VUE_APP_COOKIE_NAME,
      paths: ["params", "personalPayment"],
      storage: {
        getItem: (key) => Cookies.get(key),
        setItem: (key, value) =>
          Cookies.set(key, value, {
            domain: process.env.VUE_APP_COOKIE_DOMAIN,
            expires: 7,
            secure: true
          }),
        removeItem: (key) => Cookies.remove(key)
      }
    }),
    createPersistedState({
      key: process.env.VUE_APP_COOKIE_NAME,
      paths: ["order", "plan"],
      storage: window.sessionStorage
    })
  ],
  strict: process.env.NODE_ENV !== CONST_DATA.ENV.PRODUCTION,  
})
